// Outlet.jsx
import React, { useState, useEffect, useRef } from "react";
import { FaHome, FaBell } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { BsCart2 } from "react-icons/bs";
import logo from "../assets/Img/logo.png";
import "../assets/Css/Dashboard.css";
import { useLocation, useNavigate } from "react-router-dom";
import bg_logo from "../assets/Img/bg_red.png";
import { PiSignpost } from "react-icons/pi";
import { LiaAdSolid } from "react-icons/lia";
const Outlet = ({ children }) => {
  const [hasNotification] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const profileRef = useRef(null);
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/");
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowLogout(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="layout">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="logo-rentel">
          <img src={logo} alt="Rentel Logo" />
        </div>
        <ul className="sidebar-menu">
          <li
            className={location.pathname === "/dashboard" ? "active" : ""}
            onClick={() => navigate("/dashboard")}
            style={{ cursor: "pointer" }}
          >
            <FaHome /> <span>Dashboard</span>
          </li>

          <li
            className={location.pathname === "/usermanagement" ? "active" : ""}
            onClick={() => navigate("/usermanagement")}
            style={{ cursor: "pointer" }}
          >
            <FiUsers /> <span>User Management</span>
          </li>

          <li
            className={
              location.pathname === "/ListingsManagement" ? "active" : ""
            }
            onClick={() => navigate("/ListingsManagement")}
            style={{ cursor: "pointer" }}
          >
            <BsCart2 /> <span>Listings Management</span>
          </li>

          <li
            className={location.pathname === "/Banners" ? "active" : ""}
            onClick={() => navigate("/Banners")}
            style={{ cursor: "pointer" }}
          >
            <PiSignpost /> <span>Add Banners</span>
          </li>
          <li
            className={location.pathname === "/AdsManagement" ? "active" : ""}
            onClick={() => navigate("/AdsManagement")}
            style={{ cursor: "pointer" }}
          >
            <LiaAdSolid /> <span>Ads Management</span>
          </li>
        </ul>
      </div>

      {/* Main area */}
      <div className="main-area">
        {/* Header */}
        <div className="header">
          <div className="header-right">
            <div className="notification-wrapper">
              <FaBell className="notification-icon" />
              {hasNotification && <span className="dot" />}
            </div>
            <div
              className="user-profile"
              style={{ position: "relative" }}
              onMouseEnter={() => setShowLogout(true)}
              onMouseLeave={() => setShowLogout(false)}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <img
                  src={bg_logo}
                  alt="User"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    marginRight: 8,
                  }}
                />
                <div>
                  <strong>Rentel</strong>
                  <div className="role">Admin</div>
                </div>
              </div>

              {showLogout && (
                <div className="logout-dropdown">
                  <button onClick={handleLogout}>Logout</button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Children pages */}
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default Outlet;
